// app/javascript/helpers/format-helper.js
export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return num.toString();
}

export function parseCleaveInput(val) {
  if (val === null || val === undefined || val.toString().trim() === "") return null

  let result = val.trim().replace(/[.€%]/g, '').replace(",", '.');
  if (result) {
    return parseFloat(result);
  } else {
    return null;
  }
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value)
}
